/**
 * Size chart (storefront): a "Size chart" link among the selectors — after
 * the size selector when `size-chart` comes after `options` in the store's
 * product model (the slots render in STORE_PRODUCT_MODEL order) — opening
 * the product's chart in a dialog.
 *
 * The chart arrives resolved (`product.sizeChartTable`: the product's own or
 * its category's, in the page's language — aldoo-na size-chart). No chart, no
 * link.
 */
import React, { useState } from "react"
import Modal from "aldoo-ra/Modal"
import SizeChartTable from "./SizeChartTable"
import { useStoreExtensionText } from "../texts"

// a ruler: what the link is about, at a glance
const RulerIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 15.5 15.5 3 21 8.5 8.5 21 3 15.5Zm4-4 2 2m1-5 2 2m1-5 2 2m-8 6 1.5 1.5" />
  </svg>
)

export function SizeChartLink({ product }) {
  const text = useStoreExtensionText()
  const [open, setOpen] = useState(false)
  const table = product?.sizeChartTable
  if (!table?.rows?.length) return null
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 self-start text-sm font-medium underline underline-offset-4 hover:text-primary"
        data-testid="size-chart-link"
      >
        <RulerIcon className="w-5 h-5" />
        {text("size_chart")}
      </button>
      <Modal
        isOpen={open}
        onClose={() => setOpen(false)}
        title={table.label || text("size_chart")}
        closeOnEscape
        closeOnClickOutside
        className="md:max-w-[720px]"
      >
        <SizeChartTable table={table} />
      </Modal>
    </>
  )
}

export const StorefrontExtension = {
  id: "size-chart",
  label: "Size chart",
  slots: { selectors: SizeChartLink },
}
